import { useMemo } from 'react';

import { NameAndCreateDateFormatter, DragHandlerFormatter } from '@Components/Grid/components/Table/formatters';
import column, { defaultActionsColumn, defaultColumnId, deleteAction, editAction, toggleFormatter } from '@Components/Grid/utils/column';

export default function useColumns() {
  return useMemo(() => [
    column.accessor('drag-handler', {
      header: '',
      enableSorting: false,
      cell: info => <DragHandlerFormatter info={info} />,
      className: 'w-10',
    }),
    defaultColumnId({ enableSorting: false }),
    column.accessor('name', {
      header: 'Name',
      cell: info => <NameAndCreateDateFormatter info={info} />,
      enableSorting: false,
      className: 'w-[70vw]',
    }),
    column.accessor('active', {
      header: 'Active',
      cell: info => toggleFormatter(info),
      enableSorting: false,
    }),
    defaultActionsColumn(editAction, deleteAction),
  ], [])
}
